import { settingsBreadcrumbs } from '../settings-breadcrumbs';

const customAttributesCrumb = {
  label: 'global.sidebar.custom_attributes_trans',
  route: { name: 's-custom-attributes' },
};

const custom_attrbutes_routes = [
  {
    path: 'custom-attributes',
    name: 'custom-attributes',
    redirect: { name: 's-custom-attributes' },
    meta: {
      permissions: 'read-custom-attributes',
    },
    children: [
      {
        path: '',
        name: 's-custom-attributes',
        component: () => import('@/views/System/Settings/CustomAttributes/CustomAttributesList.vue'),
        meta: {
          permissions: 'read-custom-attributes',
          breadcrumbs: settingsBreadcrumbs(customAttributesCrumb),
        },
      },
      {
        path: 'add',
        name: 's-custom-attributes-add',
        component: () => import('@/views/System/Settings/CustomAttributes/Components/CustomAttributesForm.vue'),
        meta: {
          permissions: 'write-custom-attributes',
          breadcrumbs: settingsBreadcrumbs(customAttributesCrumb),
        },
      },
      {
        path: ':id',
        name: 's-custom-attributes-edit',
        component: () => import('@/views/System/Settings/CustomAttributes/Components/CustomAttributesForm.vue'),
        meta: {
          permissions: 'update-custom-attributes',
          breadcrumbs: settingsBreadcrumbs(customAttributesCrumb),
        },
      },
    ],
  },
];

export default custom_attrbutes_routes;
